// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorCard_container__E_Iuv","image":"AuthorCard_image__2NJ_Z","content":"AuthorCard_content__6lYod","title":"AuthorCard_title__7PFI6"};